import {  createJSONStorage, persist } from "zustand/middleware";
import { createUserSlice, UserSlice } from "./user-slice";
import { createDetectionSlice, DetectionSlice } from "./detection-slice";
import { create } from 'zustand'

export const useStore = create<UserSlice & DetectionSlice>()(persist((set, get, store) => ({
  ...createUserSlice(set, get, store),
  ...createDetectionSlice(set, get, store),
}), {
  name: "store",
  storage: createJSONStorage(() => localStorage),
  version: 5,
  partialize: (state) => ({
    mapBounds: state.mapBounds,
    mapZoom: state.mapZoom,
    mapStyle: state.mapStyle,
    mapStyleUrl: state.mapStyleUrl,
    mapProjection: state.mapProjection,
    alertsEnabled: state.alertsEnabled,
    shouldShowAircraft: state.shouldShowAircraft,
    shouldShowFlightRestrictions: state.shouldShowFlightRestrictions,
    shouldShowPublicFlightPlans: state.shouldShowPublicFlightPlans,
    zoneTypeFilter: state.zoneTypeFilter,
    minAltitude: state.minAltitude,
    maxAltitude: state.maxAltitude,
  }),
}));
